/* eslint-disable */
+(function ($) {
  'use strict';

  var modals = $('.modal.multi-step');

  modals.each(function (idx, modal) {
    var $modal = $(modal),
      $steps = $modal.find('.modal-step'),
      total_num_steps = $steps.length,
      reset_on_close = true,
      $btn_prev = $modal.find('.modal-footer .btn-prev'),
      $btn_next = $modal.find('.modal-footer .btn-next'),
      $progress_display = $modal.find('.modal-footer .step-progress');

    // var $buttons = $modal.find('button.step');
    // var total_num_steps = $buttons.length;
    // var $progress = $modal.find('.m-progress');
    // var $progress_bar = $modal.find('.m-progress-bar');
    // var $progress_stats = $modal.find('.m-progress-stats');
    // var $progress_current = $modal.find('.m-progress-current');
    // var $progress_total = $modal.find('.m-progress-total');
    // var $progress_complete  = $modal.find('.m-progress-complete');
    // var reset_on_close = $modal.attr('reset-on-close') === 'true';

    function setNavStatus() {
      $btn_prev.hide();
      $btn_next.hide();

      if ($modal.data('total_num_steps') > 0) {
        if ($modal.data('current_step') < $modal.data('total_num_steps')) {
          $btn_next.show();
        }
        if ($modal.data('current_step') > 1) {
          $btn_prev.show();
        }
      }

      $progress_display.text($modal.data('current_step') + ' of ' + $modal.data('total_num_steps'));
    }

    function goToStep(step) {
      $steps.hide();
      $($steps[step - 1]).show();
      $modal.data({
        current_step: step,
      });
      setNavStatus();
    }

    function handleNext() {
      if ($modal.data('current_step') < $modal.data('total_num_steps')) {
        goToStep($modal.data('current_step') + 1);
      }
    }

    function handlePrev() {
      if ($modal.data('current_step') > 1) {
        goToStep($modal.data('current_step') - 1);
      }
    }

    function handleButtonPress(e) {
      if (e.which === 39) {
        handleNext();
      } else if (e.which === 37) {
        handlePrev();
      }
    }

    function reset() {
      $modal.find('.modal-step').hide();
      $modal.find('.modal-step:first-child').show();
      $modal.data({
        current_step: 1,
        total_num_steps: total_num_steps,
      });

      setNavStatus();
    }

    function initialize() {
      reset();

      $btn_next.on('click', handleNext);
      $btn_prev.on('click', handlePrev);

      $modal
        .on('shown.bs.modal', function () {
          $(document).on('keydown', handleButtonPress);
        })
        .on('hidden.bs.modal', function () {
          $(document).off('keydown', handleButtonPress);
        });

      if (reset_on_close) {
        $modal.on('hidden.bs.modal', function () {
          reset();
        });
      }
    }

    initialize();
  });
})(jQuery);
